module.exports = __webpack_public_path__ + "img/multiplier.7b923fd6.png";